<app-modal-template title="Tenant Job Service">
    <div class="modal-body-content mb-3">
      <div class="loadingDiv" *ngIf="isRunning">
        <div class="loader"></div>
      </div>
      <div>
        <span>Are you sure you want to run the {{tenantName}} ETL job?</span>
      </div>
      
    </div>
    <div class="modal-footer-content">
      <div class="d-flex">
        <button mat-button class="btn btn-secondary" [disabled]="isRunning"
          (click)="onCloseModal();">Cancel</button>
        <button type="submit" class="btn btn-primary ml-auto" [disabled]="isRunning"
          (click)="onRunJobButtonClick();">Run Job</button>
      </div>
    </div>
  </app-modal-template>